import React, { useState, useEffect, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Fetcher } from "../../Helpers/fetcher";
import './index.css';
import {  Accordion } from 'react-bootstrap';
import SuperAdminOrSubMenu from './component/SuperAdminOrSubMenu';
import TopNav from './component/TopNav';
import { filterNavDataForSuperAdminOrSub } from '../../Helpers/superAdminMenu';
import { getPerms, setModuleListing, setPerms } from '../../Helpers/perms';

const SideNav = (props) => {
	let urlPrefix;
	if (props.app.mode === 'dev') {
		urlPrefix = '/build';
	} else {
		urlPrefix = '';
	}
	const apiPath = props.app.apiPath;
	const userId = props.app.userId;
	const isSubSuperAdmin = props.app.isSubSuperAdmin

	const [moduleId, setModuleId] = useState();
	const [apiModuleId, setApiModuleId] = useState();
	const [dedicatedCliModuleId, setDedicatedCliModuleId] = useState();
	const [ivrId, setIvrId] = useState();
	const [inboundId, setInboundId] = useState();
	const [ttsId, setTtsId] = useState();
	const [smsModuleId, setSmsModuleId] = useState();
	const [continousCampaignId, setContinousCampaignId] = useState();
	const [reportModule, setReportModule] = useState(false)
	const [aclId, setAclId] = useState(null);
	const [permissions, setPermissions] = useState(() => {
		return getPerms() || {};
	});
	const [loading, setLoading] = useState(false)
	const [sidebarPosition, setSidebarPosition] = useState('left')
	const [apiDocsSheets, setApiDocsSheets] = useState([])
	const [apiDocsDocuments, setApiDocsDocuments] = useState([])
	// Resolved from whichever sub-superadmin's ACL a reseller/user was created
	// under (see the effective-ACL useEffect below) -- null means "no restricting
	// ancestor found, don't hide anything" (e.g. created directly by superadmin).
	const [inheritedPermission, setInheritedPermission] = useState(null)
	// Accepts either a flat module name ("TTS Plans") or a dotted "Parent.Child"
	// path (e.g. "Manage Campaign.Prompt Voice Campaign Summary") -- same
	// array-of-single-key-objects children traversal as hasPermission in
	// Container/index.js, just against the INHERITED (parent sub-superadmin's)
	// permission object instead of the current user's own.
	const isInheritedModuleAllowed = (modulePath) => {
		if (!inheritedPermission) return true;

		const pathParts = modulePath.split(".");
		let currentPermission = undefined;

		for (let i = 0; i < pathParts.length; i++) {
			const part = pathParts[i];
			if (i === 0) {
				currentPermission = inheritedPermission[part];
			} else if (Array.isArray(currentPermission?.children)) {
				const childWrapper = currentPermission.children.find(
					(c) => Object.keys(c)[0] === part
				);
				currentPermission = childWrapper ? childWrapper[part] : undefined;
			} else {
				currentPermission = undefined;
			}
			if (!currentPermission) break;
		}

		if (!currentPermission) return false;
		return !!currentPermission.view_permission;
	};

	const getAclDetail = async (id) => {
		if (!id) return;

		props.app.setGlobalLoading(true);
		try {
			const res = await Fetcher.get(
				`${apiPath}/api/obd/get/acl/setting/${id}`
			);

			const permission = res?.moduleOperation
				? (typeof res.moduleOperation === "string"
					? JSON.parse(res.moduleOperation)
					: res.moduleOperation)
				: {};

			const moduleListing = res?.moduleListingData
				? (typeof res.moduleListingData === "string"
					? JSON.parse(res.moduleListingData)
					: res.moduleListingData)
				: {};
			setPerms(permission) //local storage
			setModuleListing(moduleListing) //local storage
			setPermissions(permission);
			props.setPermission(permission)
			props.setModuleListingData(moduleListing)
		} finally {
			props.app.setGlobalLoading(false);
		}
	};
	useEffect(() => {
		Fetcher.get(apiPath + "/api/obd/user/profile/" + userId)
			.then((res) => {
				console.log(res);
				let modules = res.modules;
				setAclId(res?.aclId);
				if (isSubSuperAdmin && !res?.aclId) {
					// No ACL assigned to this account -- there's nothing to wait
					// for, so stop blocking the UI on the global loading gate.
					props.app.setGlobalLoading(false);
				}
				if (modules.length > 0) {
					for (let i = 0; i <= modules.length; i++) {
						if (modules[i]?.moduleId === 3) {
							setModuleId(3);
						}
						if (modules[i]?.moduleId === 4) {
							setApiModuleId(4);
						}
						if (modules[i]?.moduleId === 5) {
							setDedicatedCliModuleId(5);
						}
						if (modules[i]?.moduleId === 1) {
							setIvrId(1);
						}
						if (modules[i]?.moduleId === 6) {
							setInboundId(6);
						}
						if (modules[i]?.moduleId === 7) {
							setTtsId(7);
						}
						if (modules[i]?.moduleId === 9) {
							setSmsModuleId(9);
						}

						if (modules[i]?.moduleId === 10) {
							setContinousCampaignId(10)
						}
						if (modules[i]?.moduleId === 11 || modules[i]?.moduleId === 12) {
							setReportModule(true)
						}
					}
				}
			})
			.catch((err) => {
				console.log("Error in fetching Users data", err);
				// Profile fetch failed -- aclId will never arrive, so don't
				// leave a sub-superadmin stuck on the global loading gate.
				if (isSubSuperAdmin) {
					props.app.setGlobalLoading(false);
				}
			});

	},[props.app.apiPath,props.app.userId]);

	useEffect(() => {
		const applyUiSettings = (res) => {
			const parsed = res?.json ? JSON.parse(res.json) : {};
			if (parsed?.themeColor) {
				document.documentElement.style.setProperty('--brand-color', parsed.themeColor);
			}
			const validPositions = ['left', 'right', 'top'];
			const resolvedPosition = validPositions.includes(parsed?.sidebarPosition) ? parsed.sidebarPosition : 'left';
			document.documentElement.setAttribute('data-sidebar-position', resolvedPosition);
			setSidebarPosition(resolvedPosition);
		};

		// UI prefs (brand color, sidebar position, ...) are copied onto a
		// user's own ui_settings ONLY at the moment they're created (see
		// CreateUser/CreateSubUser/copyUiSettingsToNewUser) -- a later change to
		// the governing sub-superadmin's own prefs never propagates to that
		// stale copy. So a reseller/user/sub-user reads the CURRENT governing
		// sub-superadmin's live ui_settings instead of their own one-time copy;
		// a sub-superadmin/superadmin still just reads their own.
		if (!isSubSuperAdmin && props.app.role !== 'ROLE_SADMIN') {
			Fetcher.get(`${apiPath}/api/obd/user/effective/parent/${userId}`)
				.then((res) => {
					const effectiveUserId = res?.parentUserId || userId;
					return Fetcher.get(`${apiPath}/api/obd/user/${effectiveUserId}/ui/settings`);
				})
				.then(applyUiSettings)
				.catch((err) => {
					console.log("Error in fetching theme color", err);
				});
		} else {
			Fetcher.get(`${apiPath}/api/obd/user/${userId}/ui/settings`)
				.then(applyUiSettings)
				.catch((err) => {
					console.log("Error in fetching theme color", err);
				});
		}
	}, [apiPath, userId, isSubSuperAdmin, props.app.role]);

	useEffect(() => {
		if (!isSubSuperAdmin) return;
		if (!aclId) return;
		props.app.setGlobalLoading(true);
		const cached = getPerms();
		if (cached && Object.keys(cached).length > 0) {
			// Show the cached permissions immediately so the sidebar isn't blank
			// while the fresh copy loads -- but always refetch below. An ACL can
			// be edited (permissions revoked) after it was cached, and a
			// sub-superadmin must never be stuck seeing stale/removed permissions
			// just because a previous session already cached them.
			setPermissions(cached);
			props.setPermission(cached);
			props.app.setGlobalLoading(false);
		}

		getAclDetail(aclId);
	}, [isSubSuperAdmin, aclId]);

	useEffect(() => {
		// A reseller/end-user has no ACL of their own, but their sidebar must
		// still respect whichever sub-superadmin's ACL they were created under --
		// otherwise a module the parent was never granted (TTS Plans, API Docs, ...)
		// keeps showing for everyone underneath them.
		if (props.app.role !== 'ROLE_ADMIN' && props.app.role !== 'ROLE_USER') return;
		let cancelled = false;

		Fetcher.get(`${apiPath}/api/obd/user/effective/acl/${userId}`)
			.then((res) => {
				if (cancelled) return;
				if (!res?.aclId) {
					setInheritedPermission(null);
					return undefined;
				}
				return Fetcher.get(`${apiPath}/api/obd/get/acl/setting/${res.aclId}`)
					.then((aclRes) => {
						if (cancelled) return;
						const permission = aclRes?.moduleOperation
							? (typeof aclRes.moduleOperation === "string" ? JSON.parse(aclRes.moduleOperation) : aclRes.moduleOperation)
							: {};
						setInheritedPermission(permission);
					});
			})
			.catch((err) => {
				console.log("Error resolving effective ACL for reseller/user sidebar", err);
			});

		return () => { cancelled = true; };
	}, [props.app.role, apiPath, userId]);

	useEffect(() => {
		// Powers the "API Docs" sidebar sub-menu below (ROLE_USER/ROLE_ADMIN
		// only) -- one sub-item per document superadmin has published.
		if (props.app.role !== 'ROLE_USER' && props.app.role !== 'ROLE_ADMIN') return;
		Fetcher.get(`${apiPath}/api/obd/sheet/content/list/${userId}`)
			.then((res) => setApiDocsSheets(Array.isArray(res) ? res : []))
			.catch((err) => console.log('Error in fetching Api Docs sheet list', err));
		Fetcher.get(`${apiPath}/api/obd/document/list/${userId}`)
			.then((res) => setApiDocsDocuments(Array.isArray(res) ? res : []))
			.catch((err) => console.log('Error in fetching Api Docs document list', err));
	}, [apiPath, userId, props.app.role]);


	const sMenuData = useMemo(() => {
		return filterNavDataForSuperAdminOrSub(urlPrefix, isSubSuperAdmin,permissions)
	}, [isSubSuperAdmin, permissions])
	// console.log({sMenuData,permissions})

	// Data-driven equivalent of the hardcoded ROLE_USER <ul className="nav"> block
	// further down (used for 'left'/'right' sidebar modes). Kept in the EXACT same
	// order, with the EXACT same labels/icons/routes/conditionals, so that <TopNav>
	// can render the polished horizontal menu for end-users too when
	// sidebarPosition === 'top'.
	const roleUserMenuData = useMemo(() => [
		{ label: 'Dashboard', icon: 'fa fa-dashboard', to: '/' },
		{ label: 'Credits History', icon: 'fa fa-history', to: `${urlPrefix}/credits-history` },
		{ label: 'Activity Logs', icon: 'fa fa-clock-o', to: `${urlPrefix}/activity-logs` },
		{ label: 'Manage CLI', icon: 'fa fa-history', to: `${urlPrefix}/user-archive-cli-list` },
		...(isInheritedModuleAllowed('API Docs') ? [{
			label: 'API Docs', icon: 'fa fa-book', children: [
				...((apiDocsSheets.length === 0 && apiDocsDocuments.length === 0) ? [] : [
					...apiDocsSheets.map(sheet => ({ label: sheet.sheetName, icon: 'fa fa-file-text', to: `${urlPrefix}/api-docs/${sheet.id}` })),
					...apiDocsDocuments.map(doc => ({ label: doc.documentName, icon: 'fa fa-file-o', to: `${urlPrefix}/api-docs/document/${doc.id}` })),
				]),
			],
		}] : []),
		...(continousCampaignId !== 10 ? [{
			label: 'Manage Users', icon: 'fa fa-user', children: [
				{ label: 'Create Sub User', icon: 'fa fa-plus', to: `${urlPrefix}/create-sub-user` },
				{ label: 'Sub User List', icon: 'fa fa-list', to: `${urlPrefix}/sub-user-list` },
			],
		}] : []),
		...(ivrId === 1 ? [{
			label: 'Custom IVR', icon: 'fa fa-chip', children: [
				{ label: 'Add Custom IVR', icon: 'fa fa-plus', to: `${urlPrefix}/add-custom-ivr` },
				{ label: 'IVR List', icon: 'fa fa-list', to: `${urlPrefix}/ivr-list` },
			],
		}] : []),
		...(continousCampaignId === 10 ? [{
			label: 'TTS Flow', icon: 'fa fa-bullhorn', children: [
				{ label: 'Add TTS Flow', icon: 'fa fa-plus', to: `${urlPrefix}/create-tts-flow` },
				{ label: 'TTS Flow List', icon: 'fa fa-list', to: `${urlPrefix}/tts-flow-list` },
				{ label: 'TTS Logs', icon: 'fa fa-list', to: `${urlPrefix}/tts-flow-logs` },
			],
		}] : []),
		{
			label: 'Voice Campaigns', icon: 'fa fa-plus-circle', children: [
				{ label: 'Compose Campaign', icon: 'fa fa-plus', to: `${urlPrefix}/add-voice-campaign` },
				{ label: 'Live Summary', icon: 'fa fa-list', to: `${urlPrefix}/voice-campaign-summary` },
				{ label: 'Historical Summary', icon: 'fa fa-list', to: `${urlPrefix}/historical-voice-campaign-summary` },
				...(continousCampaignId !== 10 ? [{ label: 'Schedule Summary', icon: 'fa fa-list', to: `${urlPrefix}/schedule-voice-campaign-summary` }] : []),
				{ label: 'Campaign Operations', icon: 'fa fa-tasks', to: `${urlPrefix}/campaign-operations` },
				...(continousCampaignId === 10 ? [{ label: 'CvC Summary', icon: 'fa fa-table', to: `${urlPrefix}/cvc-summary` }] : []),
				...(continousCampaignId !== 10 ? [{ label: 'SubUser Report', icon: 'fa fa-list', to: `${urlPrefix}/sub-user-report` }] : []),
			],
		},
		{
			label: 'Reports', icon: 'fa fa-file', children: [
				{ label: 'Download Report', icon: 'fa fa-download', to: `${urlPrefix}/download-report` },
				{ label: 'Call Detail Records', icon: 'fa fa-phone', to: `${urlPrefix}/call-detail-records` },
				...(reportModule ? [{ label: 'Report Scheduling', icon: 'fa fa-calendar-check-o', to: `${urlPrefix}/report-scheduling` }] : []),
			],
		},
		{
			label: 'Voice Blacklist', icon: 'fa fa-ban', children: [
				{ label: 'Add to Blacklist', icon: 'fa fa-plus', to: `${urlPrefix}/add-voice-blacklist` },
				{ label: 'Add Bulk Blacklist', icon: 'fa fa-plus', to: `${urlPrefix}/bulk-voice-blacklist` },
				{ label: 'View Blacklist', icon: 'fa fa-list', to: `${urlPrefix}/voice-blacklist` },
			],
		},
		{
			label: 'Voice Library', icon: 'fa fa-music', children: [
				{ label: 'Add Voice File', icon: 'fa fa-plus', to: `${urlPrefix}/add-voice-files` },
				{ label: 'View Voice Files', icon: 'fa fa-list', to: `${urlPrefix}/voice-files` },
				...(ttsId === 7 ? [{ label: 'View TTS', icon: 'fa fa-list', to: `${urlPrefix}/tts-list` }] : []),
			],
		},
		...(moduleId === 3 ? [{
			label: 'Manage Web Hook', icon: 'fa  fa-chain', children: [
				{ label: 'Add Webhook', icon: 'fa fa-plus-circle', to: `${urlPrefix}/add-webhook` },
				{ label: 'View Webhook', icon: 'fa fa-table', to: `${urlPrefix}/webhook-list` },
			],
		}] : []),
		...(smsModuleId === 9 ? [{
			label: 'Manage Sms Web Hook', icon: 'fa  fa-chain', children: [
				{ label: 'Add Sms Webhook', icon: 'fa fa-plus-circle', to: `${urlPrefix}/add-sms-webhook` },
				{ label: 'View Sms Webhook', icon: 'fa fa-table', to: `${urlPrefix}/sms-webhook-list` },
			],
		}] : []),
		...(apiModuleId === 4 ? [{
			label: 'Manage Api', icon: 'fa fa-cogs', children: [
				{ label: 'Create Api Key', icon: 'fa fa-plus-circle', to: `${urlPrefix}/create-api-key` },
				{ label: 'Api Key List', icon: 'fa fa-table', to: `${urlPrefix}/user-api-key-list` },
				{ label: 'Api Summary', icon: 'fa fa-table', to: `${urlPrefix}/api-key-summary-list` },
				{ label: 'Api Historical Summary', icon: 'fa fa-table', to: `${urlPrefix}/api-key-historical-summary-list` },
			],
		}] : []),
		{
			label: 'Manage Agent', icon: 'fa fa-cogs', children: [
				{ label: 'Create Agent Group', icon: 'fa fa-plus-circle', to: `${urlPrefix}/create-group-agent` },
				{ label: 'Agent Group List', icon: 'fa fa-table', to: `${urlPrefix}/group-agent-list` },
			],
		},
		...(inboundId === 6 ? [{
			label: 'Manage Inbound', icon: 'fa fa-cogs', children: [
				{ label: 'Inbound Campaign', icon: 'fa fa-table', to: `${urlPrefix}/add-inbound-campaign` },
				{ label: 'Live Inbound Summary', icon: 'fa fa-table', to: `${urlPrefix}/inbound-campaign-list` },
				{ label: 'Historical Summary', icon: 'fa fa-table', to: `${urlPrefix}/inbound-campaign-historical-list` },
			],
		}] : []),
	], [urlPrefix, isInheritedModuleAllowed, apiDocsSheets, apiDocsDocuments, continousCampaignId, ivrId, reportModule, ttsId, moduleId, smsModuleId, apiModuleId, inboundId]);

	// Data-driven equivalent of the hardcoded ROLE_ADMIN <ul className="nav"> block
	// further down (used for 'left'/'right' sidebar modes). Same ordering/labels/
	// icons/routes/conditionals as that block, so <TopNav> can render the polished
	// horizontal menu for resellers too when sidebarPosition === 'top'.
	const roleAdminMenuData = useMemo(() => [
		{ label: 'Dashboard', icon: 'fa fa-dashboard', to: '/' },
		...(isInheritedModuleAllowed('API Docs') ? [{
			label: 'API Docs', icon: 'fa fa-book', children: [
				...((apiDocsSheets.length === 0 && apiDocsDocuments.length === 0) ? [] : [
					...apiDocsSheets.map(sheet => ({ label: sheet.sheetName, icon: 'fa fa-file-text', to: `${urlPrefix}/api-docs/${sheet.id}` })),
					...apiDocsDocuments.map(doc => ({ label: doc.documentName, icon: 'fa fa-file-o', to: `${urlPrefix}/api-docs/document/${doc.id}` })),
				]),
			],
		}] : []),
		{
			label: 'Manage Users', icon: 'fa fa-user', children: [
				{ label: 'Create User', icon: 'fa fa-plus', to: `${urlPrefix}/create-user` },
				{ label: 'User List', icon: 'fa fa-list', to: `${urlPrefix}/user-list` },
				{ label: 'Credits History', icon: 'fa fa-history', to: `${urlPrefix}/credits-history` },
				{ label: 'Reseller Summary', icon: 'fa fa-list', to: `${urlPrefix}/reseller-summary` },
				{ label: 'Activity Logs', icon: 'fa fa-clock-o', to: `${urlPrefix}/activity-logs` },
				{ label: 'Voice Plan Logs', icon: 'fa fa-history', to: `${urlPrefix}/voice-plan-logs` },
			],
		},
		{
			label: 'Manage Campaign', icon: 'fa fa-bullhorn', children: [
				{ label: 'Voice Campaign Summary', icon: 'fa fa-table', to: `${urlPrefix}/voice-superadmin-campaign-summary` },
				...(isInheritedModuleAllowed('Manage Campaign.Prompt Voice Campaign Summary') ? [{ label: 'Prompt Voice Campaign Summary', icon: 'fa fa-table', to: `${urlPrefix}/prompt-voice-superadmin-campaign-summary` }] : []),
				{ label: 'Historical Campaign Summary', icon: 'fa fa-list', to: `${urlPrefix}/historical-campaign-summary-superadmin` },
			],
		},
		...(dedicatedCliModuleId === 5 ? [{
			label: 'Manage CLI', icon: 'fa fa-phone', children: [
				{ label: 'CLI List', icon: 'fa fa-list', to: `${urlPrefix}/cli-list` },
			],
		}] : []),
		{
			label: 'Voice Plans', icon: 'fa fa-wifi', children: [
				{ label: 'Add Voice Plan', icon: 'fa fa-plus', to: `${urlPrefix}/add-voice-plan` },
				{ label: 'View Voice Plans', icon: 'fa fa-list', to: `${urlPrefix}/voice-plans` },
			],
		},
		...(isInheritedModuleAllowed('TTS Plans') ? [{
			label: 'TTS Plans', icon: 'fa fa-wifi', children: [
				{ label: 'Add TTS Plan', icon: 'fa fa-plus', to: `${urlPrefix}/add-tts-plan` },
				{ label: 'View TTS Plans', icon: 'fa fa-list', to: `${urlPrefix}/tts-plans` },
			],
		}] : []),
		{
			label: 'Voice Library', icon: 'fa fa-music', children: [
				{ label: 'View Voice Files', icon: 'fa fa-list', to: `${urlPrefix}/voice-files` },
			],
		},
		...(inboundId === 6 ? [{
			label: 'Manage Inbound', icon: 'fa fa-cogs', children: [
				{ label: 'Live Inbound Summary', icon: 'fa fa-table', to: `${urlPrefix}/inbound-campaign-list` },
				{ label: 'Historical Summary', icon: 'fa fa-table', to: `${urlPrefix}/inbound-campaign-historical-list` },
			],
		}] : []),
	], [urlPrefix, isInheritedModuleAllowed, apiDocsSheets, apiDocsDocuments, dedicatedCliModuleId, inboundId]);

	const usesDataDrivenMenu = props.app.role === 'ROLE_SADMIN' || isSubSuperAdmin || props.app.role === 'ROLE_ADMIN' || props.app.role === 'ROLE_USER';

	if (sidebarPosition === 'top' && usesDataDrivenMenu) {
		const topNavMenu = props.app.role === 'ROLE_ADMIN' ? roleAdminMenuData
			: props.app.role === 'ROLE_USER' ? roleUserMenuData
			: sMenuData;
		return (
			<TopNav
				menu={topNavMenu}
				loading={loading}
				logo={props.app.logo}
				siteUrl={props.app.siteUrl}
			/>
		);
	}

	return (
		<div className="sidebar">
			<div class="sidebar__background"></div>
			<div className="scrollbar-container sidebar-nav">
				<a className="navbar-brand" href={props.app.siteUrl}>
					{props.app.logo ? (
						<img className="navbar-brand-full" src={props.app.logo} alt="Logo" />
					) : (
						<div className="navbar-brand-obd">
							<span className="navbar-brand-text">OBD</span>
							<span className="navbar-brand-icons">
								<i className="fa fa-phone" title="Call"></i>
								<i className="fa fa-life-ring" title="Support"></i>
								<i className="fa fa-user" title="Support Agent"></i>
							</span>
						</div>
					)}
				</a>

				{props.app.role === 'ROLE_SUSER' && <ul className="nav">
                      <li className="nav-item"><Link className="nav-link" to={`${urlPrefix}/sub-user-report`}><i className="mr-2 fa fa-history"></i>User Report</Link></li>
				</ul>
                }
				{props.app.role === 'ROLE_USER' && <ul className="nav">
					<li className="nav-item"><Link className="nav-link active" to="/" aria-current="page"><i className="mr-2 fa fa-dashboard"></i>Dashboard</Link></li>
					<li className="nav-item"><Link className="nav-link" to={`${urlPrefix}/credits-history`}><i className="mr-2 fa fa-history"></i>Credits History</Link></li>
					<li className="nav-item"><Link className="nav-link" to={`${urlPrefix}/activity-logs`}><i className="mr-2 fa fa-clock-o"></i>Activity Logs</Link></li>
					<li className="nav-item"><Link className="nav-link" to={`${urlPrefix}/user-archive-cli-list`}><i className="mr-2 fa fa-history"></i>Manage CLI</Link></li>
					{isInheritedModuleAllowed('API Docs') && (
					<li className='nav-group'>
						<Accordion>
							<Accordion.Item eventKey="api-docs">
								<Accordion.Header><i className="mr-2 fa fa-book"></i>API Docs</Accordion.Header>
								<Accordion.Body>
									<ul className='nav-group-items'>
										{(apiDocsSheets.length === 0 && apiDocsDocuments.length === 0) ? (
											<li className="nav-item"><span className="nav-link disabled">No documents yet</span></li>
										) : (
											<>
												{apiDocsSheets.map(sheet => (
													<li className="nav-item" key={`sheet-${sheet.id}`}>
														<Link className="nav-link" to={`${urlPrefix}/api-docs/${sheet.id}`}><i className="mr-2 fa fa-file-text"></i>{sheet.sheetName}</Link>
													</li>
												))}
												{apiDocsDocuments.map(doc => (
													<li className="nav-item" key={`doc-${doc.id}`}>
														<Link className="nav-link" to={`${urlPrefix}/api-docs/document/${doc.id}`}><i className="mr-2 fa fa-file-o"></i>{doc.documentName}</Link>
													</li>
												))}
											</>
										)}
									</ul>
								</Accordion.Body>
							</Accordion.Item>
						</Accordion>
					</li>
					)}
					<li className='nav-group'>
						<Accordion defaultActiveKey="1">
                            
							
							{(continousCampaignId!==10) && (
							<Accordion.Item eventKey="17">
							<Accordion.Header><i className="mr-2 fa fa-user"></i>Manage Users</Accordion.Header>
							<Accordion.Body>
								<ul className='nav-group-items'>							
									<li className="nav-item"><Link className="nav-link" to={`${urlPrefix}/create-sub-user`}><i className="mr-2 fa fa-plus"></i>Create Sub User </Link></li>
									<li className="nav-item"><Link className="nav-link" to={`${urlPrefix}/sub-user-list`}><i className="mr-2 fa fa-list"></i> Sub User List</Link></li>
									</ul>
								</Accordion.Body>
					     	</Accordion.Item>
							)}


						    {(ivrId === 1) && (
							<Accordion.Item eventKey="8">
								<Accordion.Header><i className="mr-2 fa fa-chip"></i> Custom IVR</Accordion.Header>
								<Accordion.Body>
								<ul className='nav-group-items'>
									<li className="nav-item"><Link className="nav-link" to={`${urlPrefix}/add-custom-ivr`}><i className="mr-2 fa fa-plus"></i>Add Custom IVR</Link></li>
									<li className="nav-item"><Link className="nav-link" to={`${urlPrefix}/ivr-list`}><i className="mr-2 fa fa-list"></i>IVR List</Link></li>
									{/* <li className="nav-item"><Link className="nav-link" to={`${urlPrefix}/add-new-custom-ivr`}><i className="mr-2 fa fa-plus"></i>Add New Custom IVR</Link></li>
									<li className="nav-item"><Link className="nav-link" to={`${urlPrefix}/new-ivr-list`}><i className="mr-2 fa fa-list"></i>New IVR List</Link></li> */}
								</ul>
								</Accordion.Body>
							</Accordion.Item>
							)}

							{(continousCampaignId==10) && (
							<Accordion.Item eventKey="18">
								<Accordion.Header><i className="mr-2 fa fa-bullhorn"></i> TTS Flow</Accordion.Header>
								<Accordion.Body>
								<ul className='nav-group-items'>
									<li className="nav-item"><Link className="nav-link" to={`${urlPrefix}/create-tts-flow`}><i className="mr-2 fa fa-plus"></i>Add TTS Flow</Link></li>
									<li className="nav-item"><Link className="nav-link" to={`${urlPrefix}/tts-flow-list`}><i className="mr-2 fa fa-list"></i>TTS Flow List</Link></li>
									<li className="nav-item"><Link className="nav-link" to={`${urlPrefix}/tts-flow-logs`}><i className="mr-2 fa fa-list"></i>TTS Logs</Link></li>
								</ul>
								</Accordion.Body>
							</Accordion.Item>
							)}
							<Accordion.Item eventKey="1">
								<Accordion.Header><i className="mr-2 fa fa-plus-circle"></i> Voice Campaigns</Accordion.Header>
								<Accordion.Body>
								<ul className='nav-group-items'>
									<li className="nav-item"><Link className="nav-link" to={`${urlPrefix}/add-voice-campaign`}><i className="mr-2 fa fa-plus"></i>Compose Campaign</Link></li>
									<li className="nav-item"><Link className="nav-link" to={`${urlPrefix}/voice-campaign-summary`}><i className="mr-2 fa fa-list"></i>Live Summary</Link></li>
									<li className="nav-item"><Link className="nav-link" to={`${urlPrefix}/historical-voice-campaign-summary`}><i className="mr-2 fa fa-list"></i>Historical Summary</Link></li>
									{(continousCampaignId!==10) && (
									<li className="nav-item"><Link className="nav-link" to={`${urlPrefix}/schedule-voice-campaign-summary`}><i className="mr-2 fa fa-list"></i>Schedule Summary</Link></li>
									)}
									<li className="nav-item"><Link className="nav-link" to={`${urlPrefix}/campaign-operations`}><i className="fa fa-tasks"></i> Campaign Operations</Link></li>
									{(continousCampaignId === 10) && (<li className="nav-item"><Link className="nav-link" to={`${urlPrefix}/cvc-summary`}><i className="fa fa-table"></i> CvC Summary</Link></li>)}
									{(continousCampaignId!==10) && (
									<li className="nav-item"><Link className="nav-link" to={`${urlPrefix}/sub-user-report`}><i className="mr-2 fa fa-list"></i>SubUser Report</Link></li>
									)}
									</ul>
								</Accordion.Body>
							</Accordion.Item>
							<Accordion.Item eventKey="3">
								<Accordion.Header><i className="mr-2 fa fa-file"></i>Reports</Accordion.Header>
								<Accordion.Body>
								<ul className='nav-group-items'>
									<li className="nav-item"><Link className="nav-link" to={`${urlPrefix}/download-report`}><i className="mr-2 fa fa-download"></i>Download Report</Link></li>
									<li className="nav-item"><Link className="nav-link" to={`${urlPrefix}/call-detail-records`}><i className="mr-2 fa fa-phone"></i>Call Detail Records</Link></li>
									{reportModule && (
										<li className="nav-item"><Link className="nav-link" to={`${urlPrefix}/report-scheduling`}><i className="mr-2 fa fa-calendar-check-o"></i>Report Scheduling</Link></li>
									)}
								</ul>
								</Accordion.Body>
							</Accordion.Item>
							<Accordion.Item eventKey="2">
								<Accordion.Header><i className="mr-2 fa fa-ban"></i>Voice Blacklist</Accordion.Header>
								<Accordion.Body>
								<ul className='nav-group-items'>
									<li className="nav-item"><Link className="nav-link" to={`${urlPrefix}/add-voice-blacklist`}><i className="mr-2 fa fa-plus"></i>Add to Blacklist</Link></li>
										<li className="nav-item"><Link className="nav-link" to={`${urlPrefix}/bulk-voice-blacklist`}><i className="mr-2 fa fa-plus"></i>Add Bulk Blacklist</Link></li>
										<li className="nav-item"><Link className="nav-link" to={`${urlPrefix}/voice-blacklist`}><i className="mr-2 fa fa-list"></i>View Blacklist</Link></li>
								</ul>
								</Accordion.Body>
							</Accordion.Item>
							<Accordion.Item eventKey="5">
								<Accordion.Header><i className="mr-2 fa fa-music"></i> Voice Library</Accordion.Header>
								<Accordion.Body>
								<ul className='nav-group-items'>
									<li className="nav-item"><Link className="nav-link" to={`${urlPrefix}/add-voice-files`}><i className="mr-2 fa fa-plus"></i>Add Voice File</Link></li>
									<li className="nav-item"><Link className="nav-link" to={`${urlPrefix}/voice-files`}><i className="mr-2 fa fa-list"></i>View Voice Files</Link></li>
								   {(ttsId === 7) && <li className="nav-item"><Link className="nav-link" to={`${urlPrefix}/tts-list`}><i className="mr-2 fa fa-list"></i>View TTS</Link></li>}
								</ul>
								</Accordion.Body>
							</Accordion.Item>
							{(moduleId === 3) && (
							<Accordion.Item eventKey="13">
								<Accordion.Header><i className="mr-2 fa  fa-chain"></i> Manage Web Hook </Accordion.Header>
								<Accordion.Body>
								<ul className='nav-group-items'>
								  <li className="nav-item"><Link className="nav-link" to={`${urlPrefix}/add-webhook`}><i className="fa fa-plus-circle"></i> Add Webhook</Link></li>
					              <li className="nav-item"><Link className="nav-link" to={`${urlPrefix}/webhook-list`}><i className="fa fa-table"></i> View Webhook</Link></li>
								</ul>
								</Accordion.Body>
							</Accordion.Item>
							)}
							{(smsModuleId === 9) && (
							<Accordion.Item eventKey="16">
								<Accordion.Header><i className="mr-2 fa  fa-chain"></i> Manage Sms Web Hook </Accordion.Header>
								<Accordion.Body>
								<ul className='nav-group-items'>
								  <li className="nav-item"><Link className="nav-link" to={`${urlPrefix}/add-sms-webhook`}><i className="fa fa-plus-circle"></i> Add Sms Webhook</Link></li>
					              <li className="nav-item"><Link className="nav-link" to={`${urlPrefix}/sms-webhook-list`}><i className="fa fa-table"></i> View Sms Webhook</Link></li>
								</ul>
								</Accordion.Body>
							</Accordion.Item>
							)}
							{(apiModuleId === 4) && (
							<Accordion.Item eventKey="12">
								<Accordion.Header><i className="mr-2 fa fa-cogs"></i> Manage Api</Accordion.Header>
								<Accordion.Body>
								<ul className='nav-group-items'>
								  <li className="nav-item"><Link className="nav-link" to={`${urlPrefix}/create-api-key`}><i className="fa fa-plus-circle"></i> Create Api Key </Link></li>
					              <li className="nav-item"><Link className="nav-link" to={`${urlPrefix}/user-api-key-list`}><i className="fa fa-table"></i> Api Key List </Link></li>
					              <li className="nav-item"><Link className="nav-link" to={`${urlPrefix}/api-key-summary-list`}><i className="fa fa-table"></i> Api Summary </Link></li>
					              <li className="nav-item"><Link className="nav-link" to={`${urlPrefix}/api-key-historical-summary-list`}><i className="fa fa-table"></i> Api Historical Summary </Link></li>
								</ul>
								</Accordion.Body>
							</Accordion.Item>
							)}

							<Accordion.Item eventKey="15">
								<Accordion.Header><i className="mr-2 fa fa-cogs"></i>Manage Agent</Accordion.Header>
								<Accordion.Body>
								<ul className='nav-group-items'>
								  <li className="nav-item"><Link className="nav-link" to={`${urlPrefix}/create-group-agent`}><i className="fa fa-plus-circle"></i> Create Agent Group</Link></li>
					              <li className="nav-item"><Link className="nav-link" to={`${urlPrefix}/group-agent-list`}><i className="fa fa-table"></i> Agent Group List</Link></li>
								</ul>
								</Accordion.Body>
							</Accordion.Item>

							{(inboundId === 6) && (
							<Accordion.Item eventKey="14">
								<Accordion.Header><i className="mr-2 fa fa-cogs"></i>Manage Inbound</Accordion.Header>
								<Accordion.Body>
								<ul className='nav-group-items'>
								  {/* <li className="nav-item"><Link className="nav-link" to={`${urlPrefix}/create-group-agent`}><i className="fa fa-plus-circle"></i> Create Agent Group</Link></li>
					              <li className="nav-item"><Link className="nav-link" to={`${urlPrefix}/group-agent-list`}><i className="fa fa-table"></i> Agent Group List</Link></li> */}
					              <li className="nav-item"><Link className="nav-link" to={`${urlPrefix}/add-inbound-campaign`}><i className="fa fa-table"></i> Inbound Campaign</Link></li>
					              <li className="nav-item"><Link className="nav-link" to={`${urlPrefix}/inbound-campaign-list`}><i className="fa fa-table"></i> Live Inbound Summary </Link></li>
								  <li className="nav-item"><Link className="nav-link" to={`${urlPrefix}/inbound-campaign-historical-list`}><i className="fa fa-table"></i> Historical Summary </Link></li>
								
								</ul>
								</Accordion.Body>
							</Accordion.Item>
							)}
						</Accordion>
					</li>
				</ul>}

				{(props.app.role === 'ROLE_ADMIN') && <ul className="nav">
					<li className="nav-item"><Link className="nav-link active" to="/" aria-current="page"><i className="fa fa-dashboard"></i> Dashboard</Link></li>
					{isInheritedModuleAllowed('API Docs') && (
					<li className='nav-group'>
						<Accordion>
							<Accordion.Item eventKey="api-docs">
								<Accordion.Header><i className="mr-2 fa fa-book"></i>API Docs</Accordion.Header>
								<Accordion.Body>
									<ul className='nav-group-items'>
										{(apiDocsSheets.length === 0 && apiDocsDocuments.length === 0) ? (
											<li className="nav-item"><span className="nav-link disabled">No documents yet</span></li>
										) : (
											<>
												{apiDocsSheets.map(sheet => (
													<li className="nav-item" key={`sheet-${sheet.id}`}>
														<Link className="nav-link" to={`${urlPrefix}/api-docs/${sheet.id}`}><i className="mr-2 fa fa-file-text"></i>{sheet.sheetName}</Link>
													</li>
												))}
												{apiDocsDocuments.map(doc => (
													<li className="nav-item" key={`doc-${doc.id}`}>
														<Link className="nav-link" to={`${urlPrefix}/api-docs/document/${doc.id}`}><i className="mr-2 fa fa-file-o"></i>{doc.documentName}</Link>
													</li>
												))}
											</>
										)}
									</ul>
								</Accordion.Body>
							</Accordion.Item>
						</Accordion>
					</li>
					)}
					<li className='nav-group'>
						<Accordion defaultActiveKey="0">
							<Accordion.Item eventKey="0">
							<Accordion.Header><i className="mr-2 fa fa-user"></i>Manage Users</Accordion.Header>
							<Accordion.Body>
								<ul className='nav-group-items'>							
									<li className="nav-item"><Link className="nav-link" to={`${urlPrefix}/create-user`}><i className="mr-2 fa fa-plus"></i>Create User </Link></li>
									<li className="nav-item"><Link className="nav-link" to={`${urlPrefix}/user-list`}><i className="mr-2 fa fa-list"></i>User List</Link></li>
									<li className="nav-item"><Link className="nav-link" to={`${urlPrefix}/credits-history`}><i className="mr-2 fa fa-history"></i>Credits History</Link></li>
								    <li className="nav-item"><Link className="nav-link" to={`${urlPrefix}/reseller-summary`}><i className="mr-2 fa fa-list"></i>Reseller Summary</Link></li>
								    <li className="nav-item"><Link className="nav-link" to={`${urlPrefix}/activity-logs`}><i className="mr-2 fa fa-clock-o"></i>Activity Logs</Link></li>
								    <li className="nav-item"><Link className="nav-link" to={`${urlPrefix}/voice-plan-logs`}><i className="mr-2 fa fa-history"></i>Voice Plan Logs</Link></li>
								</ul>
								</Accordion.Body>
							</Accordion.Item>
							<Accordion.Item eventKey="9">
								<Accordion.Header className="no-break-campaign"><i className="mr-2 fa fa-bullhorn"></i>Manage Campaign</Accordion.Header>
								<Accordion.Body>
									<ul className='nav-group-items'>
										<li className="nav-item"><Link className="nav-link" to={`${urlPrefix}/voice-superadmin-campaign-summary`}><i className="fa fa-table"></i> Voice Campaign Summary</Link></li>
										{isInheritedModuleAllowed('Manage Campaign.Prompt Voice Campaign Summary') && (
										<li className="nav-item"><Link className="nav-link" to={`${urlPrefix}/prompt-voice-superadmin-campaign-summary`}><i className="fa fa-table"></i> Prompt Voice Campaign Summary</Link></li>
										)}
										<li className="nav-item"><Link className="nav-link" to={`${urlPrefix}/historical-campaign-summary-superadmin`}><i className="mr-2 fa fa-list"></i>Historical Campaign Summary</Link></li>
									</ul>
								</Accordion.Body>
							</Accordion.Item>
							{ dedicatedCliModuleId === 5 && (
							<Accordion.Item eventKey="1">
							<Accordion.Header><i className="mr-2 fa fa-phone"></i>Manage CLI</Accordion.Header>
								<Accordion.Body>
								<ul className='nav-group-items'>
									<li className="nav-item"><Link className="nav-link" to={`${urlPrefix}/cli-list`}><i className="mr-2 fa fa-list"></i>CLI List</Link></li>
								</ul>
								</Accordion.Body>
							</Accordion.Item>
							)}
							<Accordion.Item eventKey="4">
								<Accordion.Header><i className="mr-2 fa fa-wifi"></i>Voice Plans</Accordion.Header>
								<Accordion.Body>
								<ul className='nav-group-items'>
									<li className="nav-item"><Link className="nav-link" to={`${urlPrefix}/add-voice-plan`}><i className="mr-2 fa fa-plus"></i>Add Voice Plan</Link></li>
									<li className="nav-item"><Link className="nav-link" to={`${urlPrefix}/voice-plans`}><i className="mr-2 fa fa-list"></i>View Voice Plans</Link></li>
								</ul>
								</Accordion.Body>
							</Accordion.Item>
							{isInheritedModuleAllowed('TTS Plans') && (
							<Accordion.Item eventKey="41">
							  <Accordion.Header><i className="mr-2 fa fa-wifi"></i>TTS Plans</Accordion.Header>
							  <Accordion.Body>
							  <ul className='nav-group-items'>
								<li className="nav-item"><Link className="nav-link" to={`${urlPrefix}/add-tts-plan`}><i className="mr-2 fa fa-plus"></i>Add TTS Plan</Link></li>
								<li className="nav-item"><Link className="nav-link" to={`${urlPrefix}/tts-plans`}><i className="mr-2 fa fa-list"></i>View TTS Plans</Link></li>
							  </ul>
							 </Accordion.Body>
						    </Accordion.Item>
							)}
							<Accordion.Item eventKey="5">
								<Accordion.Header><i className="mr-2 fa fa-music"></i> Voice Library</Accordion.Header>
								<Accordion.Body>
								<ul className='nav-group-items'>
									<li className="nav-item"><Link className="nav-link" to={`${urlPrefix}/voice-files`}><i className="mr-2 fa fa-list"></i>View Voice Files</Link></li>
								</ul>
								</Accordion.Body>
							</Accordion.Item>
							{(inboundId === 6) && (
							<Accordion.Item eventKey="14">
								<Accordion.Header><i className="mr-2 fa fa-cogs"></i>Manage Inbound</Accordion.Header>
								<Accordion.Body>
								<ul className='nav-group-items'>
					              <li className="nav-item"><Link className="nav-link" to={`${urlPrefix}/inbound-campaign-list`}><i className="fa fa-table"></i> Live Inbound Summary </Link></li>
								  <li className="nav-item"><Link className="nav-link" to={`${urlPrefix}/inbound-campaign-historical-list`}><i className="fa fa-table"></i> Historical Summary </Link></li>
								
								</ul>
								</Accordion.Body>
							</Accordion.Item>
							)}
						</Accordion>
					</li>
				</ul>}

				{(props.app.role === 'ROLE_SADMIN' || isSubSuperAdmin) && <SuperAdminOrSubMenu menu={sMenuData} loading={loading} />}

			</div>
		</div>
	);

}

export default SideNav;
